import React from 'react'

import Base from '../_Base'

const PerkNoAds = (props) => (
  <Base width="40" height="40" viewBox="0 0 40 40" {...props}>
    <path
      d="M20.25,29 C23.1442804,29 25.5,31.3531109 25.5,34.25 C25.5,37.1489942 23.1489942,39.5 20.25,39.5 C17.3557196,39.5 15,37.1468891 15,34.25 C15,31.3557196 17.3531109,29 20.25,29 Z M20.25,31 C18.4581767,31 17,32.4597933 17,34.25 C17,36.0418233 18.4597933,37.5 20.25,37.5 C22.0444247,37.5 23.5,36.0444247 23.5,34.25 C23.5,32.4581767 22.0402067,31 20.25,31 Z M20.25,0.5 C23.1418245,0.5 25.5,2.82967246 25.5,5.70328542 L25.5,5.70328542 L25.5,20.2967146 C25.5,23.167736 23.1444271,25.5 20.25,25.5 C17.3581755,25.5 15,23.1703275 15,20.2967146 L15,20.2967146 L15,5.70328542 C15,2.832264 17.3555729,0.5 20.25,0.5 Z M20.25,2.5 C18.4557147,2.5 17,3.94131012 17,5.70328542 L17,5.70328542 L17,20.2967146 C17,22.0602773 18.4573374,23.5 20.25,23.5 C22.0442853,23.5 23.5,22.0586899 23.5,20.2967146 L23.5,20.2967146 L23.5,5.70328542 C23.5,3.93972274 22.0426626,2.5 20.25,2.5 Z"
      fillRule="evenodd"
    />
  </Base>
)

export default PerkNoAds
